
export default  {
  methods: {
    myRound(num, precision) {
      if (!num) return num;
      return Number(Math.round(num + "e+" + precision) + "e-" + precision);
    },
    notEmptyObject(someObject){
      return Object.keys(someObject).length
    },
    isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    }
  }
}
